import React, { useState, Fragment, useEffect } from "react";
import { Table, Button, Input } from "reactstrap";
import ModalPayments from "../../Modals/ModalPayments";
import LaddaButton, { ZOOM_OUT, XS, SLIDE_LEFT } from "react-ladda";
import { LoadingMessage } from "../../Controls";
import { FormattedDate } from "react-intl";
import { FormattedNumber } from "../../../FormattedNumber/FormattedNumber";
import InfiniteScroll from "react-infinite-scroller";
import { Mode, WizzMode } from "../../types";
import { useEntities } from "../../Wizzard";
import { CircularProgress } from "../../..";
import style from "./../../styles.module.scss";
import { showToast } from "../../../../utils/Helper";
import { Quantity } from "../../../IO/Item";

const Payments = ({ mode, services, assetPayments, wizzToggle, wizzOnChange, assetId, asset }) => {
  const [readonly, setReadonly] = useState(mode == WizzMode.View);
  const [calculateView, setCalculateView] = useState(mode == WizzMode.Calculate);
  const [recalculating, setRecalculating] = useState(false);
  const [calculating, setCalculating] = useState(false); 
  const [modalPayments, setModalPayments] = useState({ open: false });
  const [deleting, setDeleting] = useEntities({});
  const [selection, setSelection] = useState({ active: false, checkeds: {} });
  const [showRealAccruals, setShowRealAccruals] = useState(false); 
  const [calculated, setCalculated] = useState(false);

  const [indice, setIndice] = useState(1)
  const [grid, setGrid] = useState({
    hasMore: assetPayments ? assetPayments.length >= 15 : false,
    payments: assetPayments ? assetPayments.slice(0, 14) : null,
    loading: false,
  });
  const [quantity, setQuantity] = useState(""); 
  const [quantityError, setQuantityError] = useState(""); 

  const [calculatedEvents, setCalculatedEvents] = useState([]);

  useEffect(() => {
    if (assetPayments) {
      setReadonly(mode == WizzMode.View);
      setGrid({
        hasMore: assetPayments ? assetPayments.length >= 15 : false,
        payments: assetPayments ? assetPayments.slice(0, 14) : null,
        loading: false,
      });
    }
  }, [assetPayments]);

  const toggle = (props) => {
    setModalPayments({ open: !modalPayments.open, ...props });
  };

  // handle grid actions
  const handleAction = (action, paymentId) => {
    if (action == Mode.Insert) {
      toggle({
        assetId,
        action,
        onConfirm: (e) => handleSave(action, e),
      });
    } else if (action == Mode.Update) {
      toggle({
        assetId,
        action,
        payment: assetPayments.find((p) => p.AssetCouponDate == paymentId),
        onConfirm: (e) => handleSave(action, e),
      });
    } else if (action == Mode.Delete) {
      wizzToggle("confirm", {
        title: "Delete payment",
        message: "Are you sure you want to delete payment?",
        onConfirm: () => handleDelete({ [paymentId]: true }),
      });
    }
  };

  // callback after modal confirm
  const handleSave = (action, payment) => {
    return services
      .updatePayment({
        assetId,
        action,
        payment,
      })
      .then((res) => res.result)
      .then((result) => {
        if (result.Code == 200) {
          if (action === Mode.Update || action === Mode.Insert) {
            forceUpdateAfterRecalculate();
          }
        } else {
          wizzToggle("message", {
            title: "Error",
            message: result.Description,
          });
        }

        return result.Code;
      });
  };

  // callback after confirm delete
  const handleDelete = (ids) => {
    setDeleting({ ...deleting, ...ids });

    services
      .deletePayments({
        assetId,
        paymentIds: Object.keys(ids),
      })
      .then((res) => res.result)
      .then((result) => {
        setDeleting(Object.keys(ids).reduce((items, value) => ({ ...items, [value]: false }), {}));
        if (result.Code == 200) {
          setGrid({
            ...grid,
            payments: grid.payments.filter((e) => !ids[e.AssetCouponDate]),
          });
          Object.keys(ids).forEach((id) =>
            assetPayments.splice(
              assetPayments.findIndex((e) => e.AssetCouponDate == id),
              1
            )
          );
          wizzOnChange({
            Payments: assetPayments,
          });
          forceUpdateAfterRecalculate();
        } else {
          wizzToggle("message", {
            title: "Error",
            message: result.Description,
          });
        }
      });
  };

  const handleSelectionAction = (action, id) => {
    if (action == "select") {
      const checkeds = {};
      assetPayments.forEach((e) => (checkeds[e.AssetCouponDate] = true));
      setSelection({
        active: true,
        checkeds,
      });
    } else if (action == "unselect") {
      const checkeds = {};
      assetPayments.forEach((e) => (checkeds[e.AssetCouponDate] = false));
      setSelection({
        active: true,
        checkeds,
      });
    } else if (action == "delete") {
      wizzToggle("confirm", {
        title: "Delete payments",
        message: "Are you sure you want to delete selected payments?",
        onConfirm: () => handleDelete(selection.checkeds),
      });
    } else if (action == "toggleCheck") {
      setSelection({
        ...selection,
        checkeds: {
          ...selection.checkeds,
          [id]: !selection.checkeds[id],
        },
      });
    }
  };

  const forceUpdateAfterRecalculate = () => {
    setGrid({ ...grid, loading: true });

    return services
      .assetInformation({ assetId })
      .then((res) => res.info.Payments)
      .then((payments) => {
        setTimeout(() => {
          wizzOnChange({
            Payments: payments,
          });
        }, 350);
      });
  };

  const handleRecalculate = () => {
    wizzToggle("confirm", {
      title: "Recalculate",
      message: "Are you sure you want to recalcute coupons?",
      onConfirm: () => {
        setRecalculating(true);
        services.couponFill({ assetId, recalculate: true }).then((res) => {
          forceUpdateAfterRecalculate().then((res) => setRecalculating(false));
        });
      },
    });
  };

  function getPrecedingDayDateFromEarliestCoupon(payments) {
    if (!payments || payments.length === 0) return null;

    var earliest = payments[0].AssetCouponDate;

    for (var i = 1; i < payments.length; i++) {
      var currentDate = payments[i].AssetCouponDate;
      if (currentDate < earliest) {
        earliest = currentDate;
      }
    }

    var earliestDate = new Date(earliest);
    earliestDate.setDate(earliestDate.getDate() - 1);

    return earliestDate.toISOString().split('T')[0]; 
  }

  const handleCalculate = () => {

    if (!quantity) {
      setQuantityError('This field is required');
      setCalculated(false);
      setShowRealAccruals(false);
      return;
    }
  
    const price = 100;

    const couponDate = getPrecedingDayDateFromEarliestCoupon(assetPayments);

    const body = {
      assetId: assetId,
      date: couponDate,
      price: price,
      quantity: quantity,
      total: 0,
      priceisclean: true,
      priceisdirty: false,
      ytm: true,
      trt: false,
    };
  
    setCalculating(true);
  
    services.calculator(body).then(function (res) {
      const result = res.result;
      const calculator = res.calculator;
    
      setCalculating(false);
    
      if (result && result.Code === 200) {
        setCalculated(true);
        setShowRealAccruals(true);
        const events = calculator.events || [];
    
        const updatedPayments = assetPayments.map((p) => {
          const matchedEvent = events.find((e) => e.date === p.AssetCouponDate && e.type === "Coupon");
          return {
            ...p,
            AssetCouponFlowInterest: matchedEvent ? parseFloat(matchedEvent.cash) : 0,
          };
        });
    
        setCalculatedEvents(events);
        wizzOnChange({ Payments: updatedPayments });
        setGrid({
          ...grid,
          payments: updatedPayments.slice(0, (indice + 1) * 15),
          hasMore: updatedPayments.length > (indice + 1) * 15,
        });
      }
    });
  };
  
  const handleChangeQuantity = (e) => {
    setQuantity(e.target.value);
    setShowRealAccruals(false); 
    setCalculated(false); 
  };

  
  const loadMore = (page) => {
    setTimeout(
      () => {
        setGrid({
          payments: assetPayments.slice(0, (page + 1) * 15),
          hasMore: assetPayments.length > (page + 1) * 15,
          loading: false,
        });
      },
      page ? 500 : 0
    );
  };

  return (
    <div className={style.payments} >
      {!readonly && (
        <div className="d-flex mb-3" style={{ height: "36px" }}>
        {!calculateView && (
          <React.Fragment>
            <Button
              color="primary"
              className="mr-2"
              onClick={() => handleAction(Mode.Insert)}
              style={{ height: "36px" }}
            >
              <i className="fa fa-plus mr-1" aria-hidden="true"></i>
              Add Payment
            </Button>
      
            <SelectActions
              setSelection={setSelection}
              selection={selection}
              doAction={handleSelectionAction}
            />
          </React.Fragment>
        )}      
          <div className="d-flex justify-content-end ml-auto">
            <div className="quantity-input-container" style={{ width: "150px" }}>
              <Input
                type="number"
                value={quantity}
                onChange={handleChangeQuantity}
                placeholder="Quantity"
                className={quantityError ? "is-invalid" : ""}
              />
              {quantityError && <div className="invalid-feedback">{quantityError}</div>}
            </div>
            <LaddaButton
              className="btn btn-ladda btn-primary mr-2"
              loading={calculating}
              onClick={handleCalculate}
              data-style={SLIDE_LEFT}
              style={{ height: "36px"}}
            >
              Calculate
            </LaddaButton>
            {!calculateView && (
            <LaddaButton
              className="btn btn-ladda btn-primary"
              loading={recalculating}
              onClick={() => handleRecalculate()}
              data-style={SLIDE_LEFT}
              style={{ height: "36px"}}
            >
              Recalculate
            </LaddaButton>
            )}
          </div>
        </div>
      )}
      <InfiniteScroll
        loadMore={loadMore}
        hasMore={grid.hasMore}
        loader={<CircularProgress sm key="payments-loader" />}
      >
        <Table responsive>
          <thead>
            <tr>
              <th />
              <th>Coupon date</th>
              <th className="text-right">Coupon rate</th>
              <th className="text-right">Capitalization rate</th>
              <th className="text-right">Sink</th>
              <th className="text-right">Principal factor</th>
              <th className="text-right">Accrual factor</th>
              <th className="text-right">Coupon number</th>
              <th className="text-right">Expected payment</th>
              <th className="text-right">Real Accrual</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
  {grid.loading ? (
    <EmptyOrLoading loading={true} />
  ) : grid.payments ? (
    <Fragment>
            {grid.payments.map((item, index) => (
              <tr key={`pay-${item.AssetCouponDate}`}>
                <td>
                  {selection.active && (
                    <Input
                      type="checkbox"
                      className={style.checkBox}
                      checked={!!selection.checkeds[item.AssetCouponDate]}
                      onChange={() => handleSelectionAction("toggleCheck", item.AssetCouponDate)}
                    ></Input>
                  )}
                </td>
                <td>
                  <FormattedDate value={`${item.AssetCouponDate}T00:00`} />
                </td>
                <td className="text-right">
                  <FormattedNumber
                    value={item.AssetCouponRate}
                    dataTypeDecimalName="currency"
                    decimalScale={5}
                  />
                </td>
                <td className="text-right">
                  <FormattedNumber
                    value={item.AssetCapitalizationRate}
                    dataTypeDecimalName="currency"
                    decimalScale={8}
                  />
                </td>
                <td className="text-right">
                  <FormattedNumber
                    value={item.AssetSink}
                    dataTypeDecimalName="currency"
                    decimalScale={8}
                  />
                </td>
                <td className="text-right">
                  <FormattedNumber
                    value={item.AssetPrincipalFactor}
                    dataTypeDecimalName="currency"
                    decimalScale={8}
                  />
                </td>
                <td className="text-right">
                  <FormattedNumber
                    value={item.AssetAccrualFactor}
                    dataTypeDecimalName="currency"
                    decimalScale={8}
                  />
                </td>
                <td className="text-right">{item.AssetCouponNumber}</td>
                <td className="text-right">
                  <FormattedNumber value={item.AssetExpectedPayment} dataTypeDecimalName="currency" />
                </td>
                <td className="text-right">
                  {calculated && showRealAccruals && (
                    <FormattedNumber
                      value={item.AssetCouponFlowInterest}
                      dataTypeDecimalName={asset.CurrencyISO === "PYG" ? "" : "currency"}
                      decimalScale={asset.CurrencyISO === "PYG" ? 0 : undefined}
                    />
                  )}
                </td>
                <td>
                  {!readonly && (
                    <Actions
                      id={item.AssetCouponDate}
                      action={handleAction}
                      deleting={!!deleting[item.AssetCouponDate]}
                    />
                  )}
                </td>
              </tr>
            ))}
            {grid.payments.length == 0 && <EmptyOrLoading />}
          </Fragment>
        ) : null}
        </tbody>
        </Table>
      </InfiniteScroll>
      <ModalPayments {...modalPayments} assetId={assetId} toggle={toggle} services={services} asset={asset} />
    </div>
  );
};

const EmptyOrLoading = ({ loading }) => (
  <tr>
    <td colSpan="9">
      {loading ? (
        <LoadingMessage text="Loading payments" />
      ) : (
        <span className="text-center d-block h5 m-3" style={{ textAlign: "center" }}>
          No payments
        </span>
      )}
    </td>
  </tr>
);

const Actions = ({ action, id, deleting }) => (
  <div className="d-flex justify-content-end" style={{ height: "36px"}}>
    <Button color="primary" size="sm" className="mr-2" onClick={() => action(Mode.Update, id)}>
      <i className="fa fa-pencil-square-o" aria-hidden="true"></i>
    </Button>

    <LaddaButton
      className="btn btn-ladda btn-danger btn-sm"
      loading={deleting}
      onClick={() => action(Mode.Delete, id)}
      data-style={ZOOM_OUT}
      data-size={XS}
    >
      <i className="fa fa-trash-o" aria-hidden="true"></i>
    </LaddaButton>
  </div>
);

const SelectActions = ({ setSelection, selection, doAction }) => {
  return (
    <div className="d-flex" style={{ height: "36px" }}>
      {selection.active ? (
        <React.Fragment>
          <Button color="light" className="ml-3 mr-2" onClick={() => doAction("select")} style={{ height: "36px"}}>
            Select All
          </Button>
          <Button color="light" className="mr-2" onClick={() => doAction("unselect")}>
            Unselect All
          </Button>
          <Button color="danger" className="mr-2" onClick={() => doAction("delete")}>
            Delete selecteds
          </Button>
          <Button onClick={() => setSelection({ ...selection, active: false })}>
            <i className="fa fa-times" aria-hidden="true" />
          </Button>
        </React.Fragment>
      ) : (
        <Button
          color="light"
          className="d-none d-lg-block"
          disabled={false}
          onClick={() => setSelection({ ...selection, active: true })}
        >
          Select items
        </Button>
      )}
    </div>
  );
};

export default Payments;
